module.exports = '3.8.1'



//////////////////
// WEBPACK FOOTER
// ./~/contentful/version.js
// module id = 411
// module chunks = 0 1